import { z } from 'zod'

/**
 * Token da sessão anônima como o `new-session` da API devolve: base64 de um GUID (`Convert.ToBase64String` do
 * `Guid.NewGuid().ToString()` no PageController). A conferência é só da forma (base64, sem espaço, tamanho de token):
 * barra página HTML, texto vazio, objeto e o texto "undefined" sem amarrar a loja ao conteúdo do GUID.
 */
export const AnonSessionTokenSchema = z.string().regex(/^[A-Za-z0-9+/]{16,200}={0,2}$/)
